<template>
  <Topics
    :articles="articles"
    v-if="!articleView"
    v-on:view-article="viewArticle"
  />
  <ViewTopic
    v-on:go-back="viewFAQ"
    :articleHTML="articleHTML"
    :loadingArticle="loadingArticle"
    v-else
  />
</template>

<script>
import { mapActions } from 'vuex'
import HalfCircleSpinner from 'epic-spinners/src/components/lib/HalfCircleSpinner'
import ViewTopic from './ViewTopic'
import Topics from './Topics'

export default {
  name: 'FAQ',
  props: ['articles'],
  components: {
    Topics,
    ViewTopic
  },
  data() {
    return {
      articleView: false,
      articleHTML: ''
    }
  },
  methods: {
    ...mapActions(['fetchArticleContent']),
    async viewArticle(id) {
      this.articleView = true
      this.loadingArticle = true
      const response = await this.fetchArticleContent(id)
      if (response.success) {
        this.articleHTML = response.data.answer
      } else {
        this.articleView = false
      }
      this.loadingArticle = false
    },
    viewFAQ() {
      this.articleView = false
    }
  }
}
</script>
